export default __webpack_public_path__ + "static/media/Canach Battle Belt.65ee98cd.jpg";